import React from 'react';
import PropTypes from 'prop-types';
import {MdTextField} from 'core/components/fields/fields';
import {ClosedContentProps, FieldText, FormProps, lovLabel, lovValue} from 'core/form/formUtils';
import {createForm, fieldStyles} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp, MdDivider} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {addSeparator} from "core/common/utils/arrayUtils";
import {Party, PartyBankAccount} from "party/partyDomain";
import {action, observable, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {observer} from "mobx-react";
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {formatInterval} from "core/common/utils/dateUtils";
import FlatButton from "material-ui/FlatButton";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import pull = require("lodash/pull");
import SvgVpnKey = require('react-icons/lib/md/vpn-key');
import {indigo500} from "material-ui/styles/colors";
import {chunkString} from "core/common/utils/stringUtils";
import {addTenantToQuery} from "core/common/utils/utils";
import securityService from "core/security/securityService";
import {PERMISSION, SECURABLE_TYPE, TSECURABLE} from "core/metamodel/metaConstant";
import {PAGE} from "routes";

interface PartyBankAccountListProps {
  partyObject: Party;
  rootObject: Party;
  entities: ObservableMap<MdEntity>;
}

@observer
export default class PartyBankAccountList extends React.Component<PartyBankAccountListProps, undefined> {


  render() {

    const {partyObject, entities, rootObject} = this.props;

    return (
      <BlockComp  noPadding={true} style={{display: 'flex', flexDirection: 'column'}} >
        {
          addSeparator( partyObject.bankAccounts.map((bankAccount, index) => <PartyBankAccountForm dataObject={bankAccount} rootObject={partyObject} key={index}
                                                                                              entities={entities} entity={entities.get('PartyBankAccount')}
                                                                                               index={index} /> ), <MdDivider inset/>)
        }
      </BlockComp>
    );
  }
}


class PartyBankAccountFormClosedContent extends React.Component<ClosedContentProps<PartyBankAccount>, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };


  @action transactions = (event) => {
    console.log('transactions');
    event.preventDefault();
    this.context.router.transitionTo("bankTransactionList", {id: this.props.dataObject.partyBankAccountId}, addTenantToQuery());
  } ;

  render() {

    let {dataObject, entity, entities, fields} = this.props;

    let txUrl = (dataObject.partyBankAccountId) ? this.context.router.makeHref("bankTransactionList", {id: dataObject.partyBankAccountId}, addTenantToQuery()) : null;

    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div className="form-text-row">
          <span className="zz-mr-5">{lovValue(dataObject.currency)}</span>
          {(dataObject.accountNumber)? <FieldText value={dataObject.getFullAccount()}/> : null}
          <FieldText label={fields.iban.textLabel} value={chunkString(dataObject.iban, 4, ' ')}/>
          <span className="zz-mr-10">{lovLabel(dataObject.bank)}</span>
          {(dataObject.validFrom || dataObject.validTo) ? <FieldText label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)}/> : null}
          <FieldText label={fields.comment.textLabel} value={dataObject.comment}/>
          {(dataObject.hasApiToken) ? <div style={{color: indigo500}}><SvgVpnKey size={20}/></div> : null}
          { (securityService.hasRight(PAGE.bankTransactionList.name as TSECURABLE, PERMISSION.Read) && txUrl) ? <FlatButton label="Transactions" href={txUrl}  primary onClick={this.transactions} /> : null}

        </div>
      </div>
    );

  }
}



@createForm({
  formName: 'PartyBankAccountForm',
  fields: [{
    name: 'bank',
    validators: ['IsRequired']
  }, {
    name: 'accountPrefix'
  }, {
    name: 'accountNumber'
  }, {
    name: 'iban'
  }, {
    name: 'currency',
    validators: ['IsRequired']
  }, {
    name: 'comment'
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }]
}, PartyBankAccountFormClosedContent)
@observer
class PartyBankAccountForm extends React.Component<FormProps<PartyBankAccount, Party>, undefined> {

  private apiDialogRef: ConfirmationDialog;

  @observable apiTokenText: string;

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.bankAccounts, this.props.dataObject);
  };

  @action setApiKey = (evt) => {
    evt.stopPropagation();
    return new Promise((resolve, reject) => {
      this.apiDialogRef.open(resolve, reject);
    }).then(() => {
      this.props.dataObject.apiToken = this.apiTokenText;
      this.props.rootObject.$dirty = true;
      if (this.apiTokenText) {
        this.props.dataObject.hasApiToken = true;
      } else {
        this.props.dataObject.hasApiToken = false;
      }
      this.apiTokenText = null;
    }).catch((e) => {
      this.apiTokenText = null;
    })
  };

  @action deleteApiKey = (evt) => {
    this.props.dataObject.apiToken = null;
    this.props.rootObject.$dirty = true;
    this.props.dataObject.hasApiToken = false;
  };


  @action onChangeApiToken = (evt) => {
    this.apiTokenText = evt.target.value;
  };

  apiDialogRefHandler = comp => this.apiDialogRef = comp;

  render() {


    const {dataObject, entity, formName, rootObject, index, entities} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {accountPrefix, accountNumber, iban, bank, currency, comment, validFrom, validTo} = fields;


    const apiTokenField = <MdTextField {...fieldStyles.small.textArea} value={this.apiTokenText} onChange={this.onChangeApiToken} fullWidth hintText="API Token" multiLine rows={5} />

    const openContent = (
      <div>
        <ConfirmationDialog ref={this.apiDialogRefHandler} cancelButtonText="Cancel" okButtonText="Ok" contentComponent={apiTokenField} title="Paste API key here"/>
        <div className="row">
          <div className="fx col-xs-6 col-md-2">
            <MdTextField {...accountPrefix.props} />
          </div>
          <div className="fx col-xs-6 col-md-4">
            <MdTextField {...accountNumber.props}/>
            <Validate field={accountNumber} value={accountNumber.props.value}/>
          </div>
          <div className="fx col-xs-12 col-md-6">
            <MdTextField {...iban.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12 col-md-10">
            <StyledSelect {...bank.props} />
            <Validate field={bank} value={bank.props.value}/>
          </div>
          <div className="fx col-xs-6 col-md-2">
            <StyledSelect {...currency.props}/>
            <Validate field={currency} value={currency.props.value}/>
          </div>
          <div className="fx col-xs-12 col-md-8">
            <MdTextField {...comment.props} />
          </div>
          <div className="fx col-xs-12 col-md-4">
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                                onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
          </div>
        </div>
      </div>


    );

    const openButtons = (
      <div>
        <FlatButton label="Set API Key" primary onClick={this.setApiKey}/>
        {(dataObject.hasApiToken) ? <FlatButton label="Delete API Key" primary onClick={this.deleteApiKey}/> : null}
      </div>
    );



    return (
      <ActiveItem openContent={openContent} closedContent={<PartyBankAccountFormClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} validate={this.props.validate} openButtons={openButtons} {...this.props} />
    );
  }
}





// WEBPACK FOOTER //
// ./src/party/component/partyBankAccountList.tsx